import ArtifactGroupType from "../base/ArtifactGroupType";


const TorpedoJar = {
  id: '151',
  name: 'Torpedo Jar',
  groupIcon: 'PathsOfIncense',
  type: ArtifactGroupType.PATH_OF_INCENSE,
  icon: 'TorpedoJar',
  power: 10,
  gameId: 'TorpedoJar'
};

export default TorpedoJar;
